import React from "react";
import "./post.css";
import Header from "./Header";
import One from "./Day/1";
import Two from "./Day/2";
import Three from "./Day/3";
import Four from "./Day/4";
import Five from "./Day/5";
import Six from "./Day/6";
import Seven from "./Day/7";
import Eight from "./Day/8";
import Nine from "./Day/9";
import Ten from "./Day/10";

export default class Layout extends React.Component {
  render() {
    return (
      <div>
        <Header />
        <h1 className="locations">Tokyo</h1>
        <One />
        <Two />
        <Three />
        <Four />
        <h1 className="locations">Kawaguchiko</h1>
        <Five />
        <h1 className="locations">Osaka</h1>
        <Six />
        <Seven />
        <Eight />
        <Nine />
        <Ten />
      </div>
    );
  }
}
